import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import { Svg } from '../common/Svg.js';

export const LoadingIndicator = function ({isLoading}) {
    if (!isLoading) {
        $('#content').removeClass('map-loading');
        return null;
    } else {
        $('#content').addClass('map-loading');
    }
    return (
        <div className={'load loading'}>
            <LoadingEllipsis/>
        </div>
    );
};

export default LoadingIndicator;
